import { motion } from 'framer-motion'
import { Calendar, CreditCard, MessageCircle, Database, TrendingUp } from 'lucide-react'

const services = [
  {
    icon: Calendar,
    title: 'Онлайн-запись',
    description: 'Автоматическая запись клиентов на услуги',
    result: 'Заполненные слоты без звонков'
  },
  {
    icon: CreditCard,
    title: 'Оплата в боте',
    description: 'ЮKassa/CloudPayments, статусы и чеки автоматически',
    result: 'Мгновенные платежи и выдача доступа'
  },
  {
    icon: MessageCircle,
    title: 'Поддержка 24/7',
    description: 'База знаний, эскалация, оценка качества обслуживания',
    result: 'Снижение нагрузки на службу поддержки'
  },
  {
    icon: Database,
    title: 'CRM-интеграции',
    description: 'Bitrix24, amoCRM, 1С для единой базы клиентов',
    result: 'Автоматическая синхронизация данных'
  },
  {
    icon: TrendingUp,
    title: 'Реализация воронок',
    description: 'Настройка продающих цепочек и автоворонок',
    result: 'Рост конверсии и автоматизация продаж'
  }
]

export default function ServicesSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Витрина решений
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Готовые модули для быстрого запуска вашего бизнеса в Telegram
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ 
                y: -8,
                transition: { duration: 0.3 }
              }}
              className="service__card group relative bg-white rounded-2xl p-8 shadow-md hover:shadow-2xl transition-all cursor-pointer border border-gray-100 overflow-hidden"
            >
              {/* Background gradient on hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-indigo-50 opacity-0 group-hover:opacity-100 transition-opacity" />
              
              <div className="relative z-10">
                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <service.icon className="w-7 h-7 text-white" strokeWidth={2} />
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {service.description}
                </p>

                {/* Result */}
                <div className="pt-4 border-t border-gray-200">
                  <p className="text-sm font-semibold text-blue-600">
                    → {service.result}
                  </p>
                </div>
              </div>

              {/* Decorative corner */}
              <div className="absolute top-0 right-0 w-20 h-20 bg-gradient-to-br from-blue-500/10 to-transparent rounded-bl-full" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
